// Include response-body reading in the deadline. Never retry a write: the server
// may already have saved it even when its response cannot reach this browser.
export async function requestWithDeadline(url, options, consume) {
  const { timeoutMs = 30000, signal, ...fetchOptions } = options;
  const controller = new AbortController();
  let timer;
  let cancel;
  const interrupted = new Promise((_, reject) => {
    cancel = () => {
      const error = new Error('Request cancelled.');
      error.name = 'AbortError';
      controller.abort();
      reject(error);
    };
    timer = setTimeout(() => {
      const error = new Error('The server took too long to respond.');
      error.name = 'TimeoutError';
      reject(error);
      controller.abort();
    }, timeoutMs);
    signal?.addEventListener('abort', cancel, { once: true });
    if (signal?.aborted) cancel();
  });
  try {
    const operation = signal?.aborted ? interrupted : fetch(url, { ...fetchOptions, signal: controller.signal }).then(consume);
    return await Promise.race([operation, interrupted]);
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener('abort', cancel);
  }
}
